/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Record_Voiceover_TitleInputs */



/**
* | output |
* | --- |
* | "Record your own voiceover" |
*
* @param {Event_Ad_Record_Voiceover_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_record_voiceover_title = /** @type {((inputs?: Event_Ad_Record_Voiceover_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Record_Voiceover_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrez votre propre voix off")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nehmen Sie Ihre eigene Sprachaufnahme auf")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registra la tua voce fuori campo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запишите свой собственный закадровый голос")
	if (locale === "es") return /** @type {LocalizedString} */ ("Graba tu propia voz en off")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("录制你自己的旁白")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自分のナレーションを録音する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपनी खुद की वॉइसओवर रिकॉर्ड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grave sua própria narração.")
	return /** @type {LocalizedString} */ ("Record your own voiceover")
});